import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
import { useNavigate } from 'react-router-dom';
const Newsletter = () => {

    const navigate = useNavigate();
    return (
        <>
            <Header />
            <Breadcrumb title="Newsletter" tabName="Newsletter" />
            <div className="innerPage">
                <div className="container">
                    <div className='row'>


                        <div className='col-lg-4 col-md-6 col-sm-6'>
                            <p className='magazine_blk_p'>NCS FINAL NEWS LETTER VOL II</p>
                            <div className='magazine_blk'>
                                <a target="_blank" onClick={() => navigate("/newsletter2", { state: { newsletter: "news1" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2.JPG" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>


                        <div className='col-lg-4 col-md-6 col-sm-6'>
                            <p className='magazine_blk_p'>Nirmal Sparks Vol I</p>
                            <div className='magazine_blk'>
                                <a target="_blank" onClick={() => navigate("/newsletter1", { state: { newsletter: "news1" } })}>
                                    <img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter1.jpg" className='magazine-block img-fluid' />
                                    <button className='mt-4'>View</button>
                                </a>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Newsletter;